module.exports = __webpack_public_path__ + "img/road-donator.db32c321.png";